import { render } from "./StaffPermission.vue?vue&type=template&id=37a5d1ad"
import script from "./StaffPermission.vue?vue&type=script&lang=js"
export * from "./StaffPermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__